import styled from 'styled-components';

const CardContainer = styled.div`
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;

  .headerTitle {
    padding-left: 8px;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 900;
    font-size: 16px;
    line-height: 24px;
    color: #1a055d;
  }
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;

  .headerTitle {
    padding-top: 4px;
    padding-bottom: 4px;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 900;
    font-size: 14px;
    line-height: 20px;
    color: #161d1f;
    padding: 10px 0px 6px 12px;
  }
  .headerTitleDisabled {
    padding-top: 4px;
    padding-bottom: 4px;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 900;
    font-size: 14px;
    line-height: 20px;
    color: #8090bb;
    padding: 10px 0px 6px 12px;
  }
`;

const CardBody = styled.div`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-top: 8px;
  color: #161d1f;
  padding: 0px 0px 8px 12px;

  img {
    padding-right: 4px;
  }

  .disabled {
    color: #8090bb;
  }
`;

export { CardContainer, CardHeader, CardBody };
